import { Navigation as ReusableNavigation } from '@goodfynd/layout';
import { useRouter } from 'next/router';

import type { NavigationProps } from './types';
import { useOrganizationNavItems } from './useOrganizationNavItems';

export const NavigationOrganization = ({
  isCollapsed = false,
}: NavigationProps) => {
  const { asPath } = useRouter();

  const navItems = useOrganizationNavItems();

  return (
    <ReusableNavigation
      isCollapsed={isCollapsed}
      items={navItems}
      isSelected={({ href = '' }) => {
        const isSelected = !!href && asPath.startsWith(href);
        return isSelected;
      }}
    />
  );
};
